import { render } from "@/components/organisms/individualCancelCode/IndividualCancelCodeResult.html?vue&type=template&id=12fd6269&external"
import script from "@/components/pages/specialFeature/spCancelCode/SpCancelCodeResult.js?vue&type=script&lang=js&external"
export * from "@/components/pages/specialFeature/spCancelCode/SpCancelCodeResult.js?vue&type=script&lang=js&external"

import "@/components/organisms/individualCancelCode/IndividualCancelCodeResult.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__